(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zojirushi-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('er-collection-tabs')) {
  customElements.define('er-collection-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) { if (this.observer) this.observer.observe(this); return; }
      this.dataset.ready = 'true';
      this.tabs = Array.from(this.querySelectorAll('[data-er-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-er-panel]'));
      this.querySelector('.er-zt__tabs').setAttribute('role', 'tablist');
      this.tabs.forEach(tab => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.getAttribute('href').slice(1));
      });
      this.panels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        const tab = this.tabs.find(item => item.dataset.erTab === panel.dataset.erPanel);
        panel.setAttribute('aria-labelledby', tab.id);
        panel.querySelector('.er-zt__track').addEventListener('scroll', () => this.updateArrows(panel), {passive:true});
      });
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-er-tab]');
       if (tab) {
  event.preventDefault();
  event.stopPropagation();
  this.select(tab.dataset.erTab);
  return;
}
        const button = event.target.closest('[data-er-step]');
        if (!button) return;
        const track = button.closest('[data-er-panel]').querySelector('.er-zt__track');
        track.scrollBy({left: Number(button.dataset.erStep) * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-er-tab]');
        if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        let index = this.tabs.indexOf(tab);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.tabs.length - 1;
        else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.select(this.tabs[index].dataset.erTab);
        this.tabs[index].focus({preventScroll:true});
      });
      this.addEventListener('shopify:block:select', event => {
        if (event.detail && event.detail.blockId) this.select(event.detail.blockId);
      });
      this.observer = new ResizeObserver(() => this.panels.filter(panel => !panel.hidden).forEach(panel => this.updateArrows(panel)));
      this.observer.observe(this);
      if (this.tabs.length) this.select(this.tabs[0].dataset.erTab);
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
    select(id) {
      if (!this.tabs.some(tab => tab.dataset.erTab === id)) return;
      this.tabs.forEach(tab => {
        const active = tab.dataset.erTab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active) {
          const strip = tab.parentElement;
          const bounds = tab.getBoundingClientRect();
          const stripBounds = strip.getBoundingClientRect();
          if (bounds.left < stripBounds.left) strip.scrollLeft += bounds.left - stripBounds.left;
          else if (bounds.right > stripBounds.right) strip.scrollLeft += bounds.right - stripBounds.right;
        }
      });
      this.panels.forEach(panel => {
        panel.hidden = panel.dataset.erPanel !== id;
        if (!panel.hidden) {panel.querySelector('.er-zt__track').scrollLeft = 0; requestAnimationFrame(() => this.updateArrows(panel));}
      });
    }
    updateArrows(panel) {
      const track = panel.querySelector('.er-zt__track');
      panel.querySelector('[data-er-step="-1"]').disabled = track.scrollLeft <= 2;
      panel.querySelector('[data-er-step="1"]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
